import React from "react";
import ReactDOM from "react-dom";
import { findCompanyDetail } from "../../../../infrastructure/repository/company-repository";
import { showErrorMessage } from "../../../commons/show-error-message";
import InformationSection from "../../components/InformationSection";
import InformationSectionRecurrent from "../../components/InformationSectionRecurrent";
import { logError, addContextLog } from "../../../../infrastructure/log";
import { translate } from "../../../../infrastructure/translate/localization";

export function renderInformationSection({
  company,
  totalAmount,
  model,
  recurrentSubsidy,
  alertId,
}) {
  let availableAmount = 0;
  if (company) {
    const cents = company.balance.amountInCents;
    const balance = cents / 100;
    availableAmount = balance - parseInt(totalAmount, 10);
  }

  const target = document.getElementById("information-section-container");

  if (target) {
    if (recurrentSubsidy) {
      ReactDOM.render(
        <InformationSectionRecurrent
          totalAmount={totalAmount}
          model={model}
          alertId={alertId}
        />,
        target
      );
    } else {
      ReactDOM.render(
        <InformationSection
          availableAmount={availableAmount}
          totalAmount={totalAmount}
          model={model}
          alertId={alertId}
        />,
        target
      );
    }
  }
}

export async function displayInformation({
  totalAmount,
  model,
  recurrentSubsidy,
  alertId,
}) {
  try {
    const { data } = await findCompanyDetail();
    renderInformationSection({
      company: data,
      totalAmount,
      model,
      recurrentSubsidy,
      alertId,
    });
    addContextLog("info", "displayInformation", "display-screen", {
      companyId: data.id,
      modelId: model.id,
    });
  } catch (e) {
    logError(e, `Error to displayInformation in model ${model.id}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
